import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import TrainLaneData from '../../data/TrainLaneData'
import { Element } from 'react-scroll'
import Train from '../../containers/Train'
import Modal from 'react-modal';
import images from '../../assets/images/home_stationnumber/*.svg'
import home_images from '../../assets/images/home/*.svg'

const customStyles = {
  content : {
    background: 'initial',
    overflow : 'initial',
    border : '0px',
    position : 'initial',
    padding : '0px',
  },
  overlay : {
    backgroundColor:'initial',
    position : 'fixed',
  }
};
 
export default class TrainPositionBranchStationRow extends React.Component {
  static propTypes = {
    lineName: PropTypes.string.isRequired,
    lines: PropTypes.array.isRequired,
    station: PropTypes.object,
    trains: PropTypes.array.isRequired,
    themeName: PropTypes.string.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  lineId() {
    const { lineName } = this.props
    return MasterData.lineIdByLineName(lineName)
  }

  trainKind(lineId, trainNumber) {
    const trainKind = MasterData.trainKindByLineIdAndTrainNumber(lineId, trainNumber)
    if (trainKind !== undefined) {
      return trainKind.kind
    }

    return null
  }

  // nextStationId に向かっている営業運転列車を返す
  trainsToward(direction, count) {
    const { station, trains, lineName } = this.props
    if (!station) return []
    var tmp_trains = trains.filter(train => (
      train.station_id === station.id &&
      train.next_station_id &&
      train.direction === direction &&
      this.trainKind(MasterData.lineIdByLineName(lineName), train.train_number)
    ))
    if (tmp_trains.length < count){
      return tmp_trains.sort((a, b) => {
        // positionは次駅に近い方から昇順に設定されているので、上りでは昇順、下りでは降順にソートする
        if (direction === 'up') {
          return a.position - b.position;
        } else {
          return b.position - a.position;
        }
      });
    } else {
      tmp_trains[0]["duplicate"] = true
      return tmp_trains
    }
  }

  // 駅の指定された方向に止まっている電車を返す
 trainsOnStation(direction, count) {
  const { station, trains, lineName } = this.props
  if (!station.eki_number) return []

  var tmp_trains = trains.filter(train => (
    train.station_id === station.id &&
    !train.next_station_id &&
    train.direction === direction &&
    this.trainKind(MasterData.lineIdByLineName(lineName), train.train_number)
  ))
  if (tmp_trains.length < count){
    return tmp_trains.sort((a, b) => {
      // positionは次駅に近い方から昇順に設定されているので、上りでは昇順、下りでは降順にソートする
      if (direction === 'up') {
        return a.position - b.position;
      } else {
        return b.position - a.position;
      }
    });
  } else {
    tmp_trains[0]["duplicate"] = true
    return tmp_trains
  }
}

  renderTrain(trains) {
    const { lineName, match, history } = this.props
    let train = trains.shift()
    return <Train
      {...this.props}
      key={`train${train.train_number}`}
      train={train}
      duplicateTrains={trains}
      lineName={lineName}
      match={match}
      history={history}
    />
  }

  stationKind() {
    const { station } = this.props
    return MasterData.stationKind(station.id)
  }

  lineKind() {
    const { station } = this.props
    return MasterData.lineKind(station.id)
  }

  lineSignal() {
    const { station } = this.props
    return MasterData.lineSignal(station.id)
  }

  lineSwitch() {
    const { station } = this.props
    return MasterData.lineSwitch(station.id)
  }

  renderLineElement() {

    var branchStart = ""
    if (this.stationKind() === "branchStart" ){
      branchStart = "is_branch_line_start"
    }
    switch(this.stationKind()) {
      case 'start':
      return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} is_branch_line ${branchStart} is_line_start`}></div>
          <div className={`d-TrainPosition-lineItem is_branch_line is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_branch_line is_${this.lineKind()} ${this.lineSignal()}`}></div>
        </div>
        )
      case 'none':
        return null
      case 'branchEnd':
        return <div className="d-TrainPosition-line is_branch_end"></div>
      default:
        return (
        <div className="d-TrainPosition-line">
          <div className={`d-TrainPosition-lineItem is_${this.lineKind()} is_branch_line ${branchStart}`}></div>
          <div className={`d-TrainPosition-lineItem is_branch_line is_${this.lineKind()} ${this.lineSignal()}`}></div>
          <div className={`d-TrainPosition-lineItem is_branch_line is_${this.lineKind()} ${this.lineSignal()}`}></div>
        </div>
        )
    }
  }

  renderAdditionalElement() {
    switch(this.stationKind()) {
      case 'branchStart':
        return <div className="d-TrainPosition-line is_branch_start"></div>
    }
  }

  renderStationName() {
    const { station, lineName, themeName } = this.props

    if (station.name_ja === null) return null

    var branchLineName = ""
    if (this.lineKind() === 'senboku'){
      branchLineName = "home_senboku_stationnumber_sb"
    } else {
      branchLineName = `home_${this.lineKind()}_stationnumber_nk`
    }
    const image_url = `${branchLineName}${station.eki_number}`

    return(
      <div className="d-TrainPosition-stationNumber is_branch_line">
        <Link to={`/lines/${lineName}/stations/${station.id}`}>
          <img src={images[image_url]} />
        </Link>
      </div>
    )
  }

  renderLineSwitch() {
    const { station, lineName } = this.props
    if (!station.transfer) return null

    return(
      <a className="d-TrainPosition-lineSwitchLink is_branch_line">
        <ul onClick={this.openModal} className="d-TrainPosition-lineSwitchList">
          {this.props.lineSwitchItem(station)}
        </ul>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick={true}
          style={customStyles}
        >
          <div key={station.id} className={`c-Modal -size-sm -upper-layer is_${lineName}`}>
            <div className="c-Modal-dialog">
              <div className="c-Modal-header">
                <p className="c-Modal-headerTitle" >乗り換え案内</p>
                <a onClick={this.closeModal}><div className="c-Modal-headerClose"></div></a>
              </div>
              <div className="c-Modal-transfer">
                <ul className="c-Modal-transferList">
                  {this.props.transferList(station)}
                </ul>
              </div>
            </div>
          </div>
        </Modal>
      </a>
    )
  }

  // trainsFilteringFunction: 列車を返す関数
  // direction: 方向
  renderTrainPositionBlockRow(trainsFilteringFunction, direction) {
    // 描画する blockRow がのぼり方向（direction === 'up'）なら、'outer', 'inner'の順番で描画する
    // 描画する blockRow がくだり方向（direction === 'down）なら、'inner', 'outer'の順番で描画する
    //var count = this.lineSignal() ? 4 : 3
    var count = 3
    var trains = trainsFilteringFunction(direction, count)
    
    return(
      <div className={`d-TrainPosition-blockRow is_branch_line is_${direction}`}>
        <div className="d-TrainPosition-blockItem">
          {trains.length < count ? trains.map(train => this.renderTrain([train])):(this.renderTrain(trains))}
        </div>

      </div>
    )
  }

  renderStationTrainPositionBlockRow(trainsFilteringFunction, direction) {
    // もし列車が1つの場合、種別によって内/外のどちらのレーンに描画すべきが変わるので renderTrainPositionBlockRow にまかせる
    //if (trains.length === 0 || trains.length === 1) {
    //  return this.renderTrainPositionBlockRow(this.trainsOnStationWithLane.bind(this), direction)
    //}

    // 描画する blockRow がのぼり方向（direction === 'up'）なら、train_kind_idの昇順ソートとする
    // →（train_kind_idが小さいものから blockItem を配置していきた）
    // 描画する blockRow がくだり方向（direction === 'down'）なら、train_kind_idの降順ソートとする
    // →（train_kind_idが大きいものから blockItem を配置していきたい）
    var count = 2
    var trains = trainsFilteringFunction(direction, count)
    if (trains.length == 0) return []

    return(
      <div className={`d-TrainPosition-blockRow is_branch_line is_${direction} is_on_station`}>
        <div className="d-TrainPosition-blockItem">
          {trains.length < count ? trains.map(train => this.renderTrain([train])):(this.renderTrain(trains))}
        </div>
      </div>
    )
  }

  render() {
    return (
      <li className="d-TrainPosition-stationItem">
        <Element id={`station${this.props.station.id}`} className={`d-TrainPosition-anchorlink`} />
        {this.renderStationName()}
        {this.renderLineSwitch()}
        {this.renderLineElement()}
        {this.renderAdditionalElement()}

        <div className="d-TrainPosition-block">
          {/* 駅の上に停車中 & 上り */}
          {this.renderStationTrainPositionBlockRow(this.trainsOnStation.bind(this), 'up')}

          {/* 駅の上に停車中 & くだり */}
          {this.renderStationTrainPositionBlockRow(this.trainsOnStation.bind(this), 'down')}

          {/* 駅間に停車中 & 上り */}
          {this.renderTrainPositionBlockRow(this.trainsToward.bind(this), 'up')}

          {/* 駅間に停車中 & くだり */}
          {this.renderTrainPositionBlockRow(this.trainsToward.bind(this), 'down')}

        </div>

      </li>
    )
  }
}
